import { StoryblokAsset } from "../../storyblok/types/fieldtypes/storyblokAsset";
import {
  getStoryblokCropURI,
  storyblokLoader,
} from "../../../components/StoryblokImage";

const getStoryblokImageUrl = (image: StoryblokAsset | unknown): string => {
  if (!image) return "";

  const isStoryblokAsset = !!(
    image &&
    typeof image === "object" &&
    "filename" in image &&
    "fieldtype" in image &&
    (image as StoryblokAsset).filename &&
    typeof (image as StoryblokAsset).filename === "string"
  );

  if (!isStoryblokAsset) return "";

  const storyblokAsset = image as StoryblokAsset;
  const cropData = storyblokAsset.meta_data?.crop;
  const cropURI = getStoryblokCropURI(cropData);
  const imageUrl = storyblokAsset.filename + cropURI;

  return storyblokLoader({
    src: imageUrl,
    width: 1920,
    quality: 100,
  });
};

export const getSchemaImageTwentyThree = (
  thumbnail: StoryblokAsset | unknown,
  schemaImage: StoryblokAsset | unknown
): string => {
  return (
    getStoryblokImageUrl(schemaImage) || getStoryblokImageUrl(thumbnail) || ""
  );
};

export const getSchemaImageYoutube = (
  thumbnail: StoryblokAsset | unknown,
  id: string,
  useYtThumbFallback?: boolean
): string => {
  const fallbackImageUrl = useYtThumbFallback
    ? `https://i.ytimg.com/vi/${id}/hqdefault.jpg`
    : `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;

  return getStoryblokImageUrl(thumbnail) || fallbackImageUrl;
};

export const getSchemaDuration = (seconds) => {
  if (!seconds) return "";

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  return `PT${hours}H${minutes}M${secs}S`;
};

export const getSchemaTitle = (
  title?: string,
  schemaTitle?: string
): string => {
  return title || schemaTitle || "";
};

export const getSchemaDescription = (
  description?: string,
  schemaDescription?: string
): string => {
  return description || schemaDescription || "";
};
